//@ts-check

/**
 * @type {import("./types").camelCaseToDashType}
 */
// for optimization purpuses have the regex in constant variable
var camelCaseToDash = function camelCaseToDash(name) {
  function dashWithLower(match) {
    return '-' + match.toLowerCase();
  }

  return name.replace(/[A-Z]{1}/g, dashWithLower);
};

export default camelCaseToDash;